import { render, staticRenderFns } from "./mo-icon.html?vue&type=template&id=29941d5f&scoped=true&external"
import script from "./mo-icon.ts?vue&type=script&lang=ts&external"
export * from "./mo-icon.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-icon.vue?vue&type=style&index=0&id=29941d5f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29941d5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/3/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29941d5f')) {
      api.createRecord('29941d5f', component.options)
    } else {
      api.reload('29941d5f', component.options)
    }
    module.hot.accept("./mo-icon.html?vue&type=template&id=29941d5f&scoped=true&external", function () {
      api.rerender('29941d5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-icon/mo-icon.vue"
export default component.exports